// components/DepositHistoryTable.jsx
import React from "react";
import { formatTimestamp } from "../../utils/format";

export default function DepositHistoryTable({ deposits = [] }) {
  if (!deposits || deposits.length === 0) {
    return (
      <div className="text-slate-400 text-center py-6">
        No deposit records yet.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto rounded-xl shadow bg-slate-900/70">
      <table className="min-w-full table-auto text-left">
        <thead>
          <tr className="text-lime-300 bg-slate-800/90">
            <th className="py-2 px-4">Date</th>
            <th className="py-2 px-4">Amount</th>
            <th className="py-2 px-4">Status</th>
            <th className="py-2 px-4">TxID</th>
          </tr>
        </thead>
        <tbody>
          {deposits.map((d) => (
            <tr key={d.id || d.txId} className="hover:bg-slate-800/70">
              <td className="py-2 px-4 text-xs sm:text-sm">
                {formatTimestamp(d.timestamp)}
              </td>
              <td className="py-2 px-4 font-bold text-lime-400">
                {d.amount ? Number(d.amount).toFixed(2) : "-"} USDT
              </td>
              <td className="py-2 px-4 font-semibold">
                <span
                  className={`px-2 py-1 rounded-full text-xs ${
                    d.status === "pending"
                      ? "bg-yellow-400/30 text-yellow-400"
                      : d.status === "approved"
                      ? "bg-lime-400/30 text-lime-400"
                      : "bg-pink-400/30 text-pink-400"
                  }`}
                >
                  {d.status
                    ? d.status.charAt(0).toUpperCase() + d.status.slice(1)
                    : "-"}
                </span>
              </td>
              <td className="py-2 px-4 break-all text-xs text-slate-400">
                {d.txid ? d.txid : "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
